import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { CountdownTimerProps } from './CountdownTimer.types'
import useCountdown from '../../modules/datetime/hooks/useCountdown'
import { MdOutlineTimer } from 'react-icons/md'
import { padDigits } from '../../utils/datetimeFormatUtils'

const CountdownTimer: React.FC<CountdownTimerProps> = ({
  datetime,
  setIsOverdue,
}) => {
  const { t } = useTranslation()
  const { hours, minutes, seconds, isOverdue } = useCountdown(
    datetime ?? new Date(),
  )

  const timeDisplay = [hours, minutes, seconds]

  useEffect(() => {
    if (isOverdue) {
      setIsOverdue?.(true)
    }
  }, [isOverdue, setIsOverdue])

  if (isOverdue) {
    return <></>
  }

  return (
    <div className="flex flex-col gap-0.5 sm:gap-1 w-full">
      <div className="flex items-center gap-2 sm:gap-3 mb-1 sm:mb-2">
        <MdOutlineTimer className="text-[var(--countdown-icon)] text-lg sm:text-2xl" />
        <div className="text-xs sm:text-sm text-[var(--countdown-text)] -ml-1 sm:-ml-2">
          {t('layout.lottoPage.clockText')}
        </div>
      </div>
      <div className="flex justify-between sm:justify-start gap-0 sm:gap-2 items-center w-full">
        {timeDisplay.map((num, idx) => (
          <div key={idx} className="flex items-center flex-1">
            {/* Number Box */}
            <h5
              className="w-full text-center px-2 sm:px-3 py-0.5 sm:py-1 rounded text-sm sm:text-lg font-semibold"
              style={{
                backgroundColor: 'var(--timer-box-bg)',
                color: 'var(--timer-box-text)',
              }}
            >
              {padDigits(num)}
            </h5>

            {/* Divider ":" */}
            {idx < timeDisplay.length - 1 && (
              <span className="text-xl sm:text-3xl mx-1 sm:ml-2 font-bold text-[var(--timer-divider)]">
                :
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default CountdownTimer
